import React, { Component } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import AdminHeader from '../components/AdminHeader';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../css/style.css';
import '../components/Home';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';


class AdminLayout extends Component {


    render() {
        if(!AuthenticationService.isUserInAdminRole()){
            return "ACCESS DENIED"
        }
        const { t } = this.props;
        return (
            <div id="container">
                <div id="header"><Header /></div>
                <div id="body">
                    <Row className="justify-content-xl-center" >
                        <Col xl={2} xs={6}  className="mt-3">
                            <Nav variant="pills" defaultActiveKey={this.props.eventKey} className="flex-column">
                                <Nav.Link href="#parameters"  eventKey="0">{t("batch-Parameters")}</Nav.Link>
                                <Nav.Link href="#userAdmin" eventKey="1">{t("user")}</Nav.Link>
                                <Nav.Link href="#adminPublicEvents" eventKey="2">{t("publicEvents")}</Nav.Link>
                                <Nav.Link href="#adminActivities" eventKey="6">{t("activities")}</Nav.Link>
                                <Nav.Link href="#adminPrivateEvents" eventKey="3">{t("privateEvents")}</Nav.Link>
                                <Nav.Link href="#adminStatistics" eventKey="4">{t("statistics")}</Nav.Link>
                                <Nav.Link href="#alarmInfo" eventKey="5">{t("warnings")}</Nav.Link>
                            </Nav>
                        </Col>
                        <Col xl={8} xs={12} >
                            <div>
                                <Row className="mt-4">
                                    <Col >
                                        <AdminHeader title={this.props.title} eventKey={this.props.eventKey} />
                                    </Col>
                                </Row>
                                <Row >
                                    <Col>{this.props.children}</Col>
                                </Row>

                            </div>

                        </Col>

                    </Row>
                </div>
                <div id="footer"><Footer /></div>
            </div>
        );
    }

}

export default translate("translations")(AdminLayout);